import { useSelector } from "react-redux";

export const useCurrentProfileData = (isDemo) => {
  const auth = useSelector((state) => state.auth);
  const demo = useSelector((state) => state.demo);

  return isDemo ? demo : auth;
};
